import React, { useEffect, useState } from 'react';
import axios from 'axios';
import qs from 'qs';
import Access from "../Components/Access";
import Navbar from "../Components/Navbar";
import {NotificationManager} from 'react-notifications';
import { ReactComponent as Trash } from '../Img/icon-trash.svg';
import Dialog from "../Components/Dialog";

const AxesInterventions = (props) =>
{
    const [axes, setAxes] = useState([]);
    const [intitule, setIntitule] = useState('');
    const [idEdit, setIdEdit] = useState(null);
    const [dialogModalVisible, setDialogModalVisible] = useState(false);
    const [idSelected, setIdSelected] = useState(null);
    const [editModalVisible, setEditModalVisible] = useState(false);
    const [editIntitule, setEditIntitule] = useState('');
    
    const purple = '#6571FE';

    async function mount()
    {
        if (!props.user || !props.user.id_budget) return;
        
        try {
            const res = await axios.post('/api/axes_interventions.php', qs.stringify({ 
                get: true, 
                id_budget: props.user.id_budget 
            }));
            if (res && res.data) {
                const list = Array.isArray(res.data) ? res.data : (res.data.data ? res.data.data : []);
                setAxes(list || []);
            } else {
                setAxes([]);
            }
        } catch (err) {
            console.warn(err);
            setAxes([]);
        }
    }

    useEffect(() => {
        if (props.user === null) {
            props.getUser();
        } else {
            mount();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.user]);

    const validateIntitule = () => {
        if (!intitule || !intitule.trim()) {
            NotificationManager.error('L\'intitulé est requis', '', 2500);
            return false;
        }
        return true;
    };

    const submit = async () => {
        if (!validateIntitule()) return;

        try {
            // Create
            const res = await axios.post('/api/axes_interventions.php', qs.stringify({
                create: true,
                id_budget: props.user.id_budget,
                intitule: intitule
            }));
            if (res && res.data && res.data.status === 1) {
                NotificationManager.success('Axe créé', '', 2000);
                clearForm();
                await mount();
            } else {
                NotificationManager.error((res && res.data && res.data.message) || 'Erreur création', '', 3000);
            }
        } catch (err) {
            console.error(err);
            NotificationManager.error('Erreur requête serveur', '', 3000);
        }
    };

    const submitEdit = async () => {
        if (!editIntitule || !editIntitule.trim()) {
            NotificationManager.error('L\'intitulé est requis', '', 2500);
            return;
        }

        try {
            const res = await axios.post('/api/axes_interventions.php', qs.stringify({
                update: true,
                id: idEdit,
                id_budget: props.user.id_budget,
                intitule: editIntitule
            }));
            if (res && res.data && res.data.status === 1) {
                NotificationManager.success('Axe mis à jour', '', 2000);
                setEditModalVisible(false);
                setIdEdit(null);
                setEditIntitule('');
                await mount();
            } else {
                NotificationManager.error((res && res.data && res.data.message) || 'Erreur mise à jour', '', 3000);
            }
        } catch (err) {
            console.error(err);
            NotificationManager.error('Erreur requête serveur', '', 3000);
        }
    };

    const editAxe = (axe) => {
        setIdEdit(axe.id);
        setEditIntitule(axe.intitule || '');
        setEditModalVisible(true);
    };

    const clearForm = () => {
        setIdEdit(null);
        setIntitule('');
    };

    async function callbackDialog(ret) {
        if (ret === true && idSelected) {
            await deleteAxeConfirmed(idSelected);
        }
        setIdSelected(null);
    }

    const deleteAxeConfirmed = async (id) => {
        try {
            const res = await axios.post('/api/axes_interventions.php', qs.stringify({ 
                delete: true, 
                id: id 
            }));
            if (res && res.data && res.data.status === 1) {
                NotificationManager.success('Axe supprimé', '', 1500);
                await mount();
            } else {
                NotificationManager.error('Erreur suppression', '', 2000);
            }
        } catch (err) {
            console.warn(err);
            NotificationManager.error('Erreur serveur', '', 2000);
        }
    };

    return (
        <div>
            <Access needConnection={true} type_user={[0,1,2]}>
                <Navbar user={props.user} />

                <Dialog
                    setModalVisible={setDialogModalVisible}
                    modalVisible={dialogModalVisible}
                    callbackDialog={callbackDialog}
                    message={"Confirmez la suppression de cet axe d'intervention :"}
                />

                {/* Modal d'édition */}
                {editModalVisible && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0,0,0,0.5)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 1000
                    }}>
                        <div 
                            onClick={e => e.stopPropagation()}
                            style={{
                            backgroundColor: 'white',
                            padding: 30,
                            borderRadius: 8,
                            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                            minWidth: 400,
                            maxWidth: 500
                        }}>
                            <h3 style={{marginTop: 0, marginBottom: 20, textAlign: 'center', color: purple}}>
                                Modifier l'axe d'intervention
                            </h3>
                            
                            <div style={{marginBottom: 20}}>
                                <label style={{display: 'block', marginBottom: 8, fontWeight: 500}}>Intitulé</label>
                                <input
                                    type="text"
                                    value={editIntitule}
                                    onChange={e => setEditIntitule(e.target.value)}
                                    style={{
                                        width: '100%',
                                        padding: 10,
                                        borderRadius: 4,
                                        border: '1px solid #ccc',
                                        fontSize: 14
                                    }}
                                    placeholder="Nom de l'axe"
                                    autoFocus
                                />
                            </div>

                            <div style={{display: 'flex', gap: 10, justifyContent: 'flex-end'}}>
                                <button
                                    onClick={() => {
                                        setEditModalVisible(false);
                                        setIdEdit(null);
                                        setEditIntitule('');
                                    }}
                                    style={{
                                        padding: '10px 20px',
                                        borderRadius: 4,
                                        backgroundColor: '#eee',
                                        border: 'none',
                                        cursor: 'pointer',
                                        fontSize: 14
                                    }}
                                >
                                    Annuler
                                </button>
                                <button
                                    onClick={submitEdit}
                                    style={{
                                        padding: '10px 20px',
                                        borderRadius: 4,
                                        backgroundColor: '#59B44A',
                                        color: 'white',
                                        border: 'none',
                                        cursor: 'pointer',
                                        fontSize: 14
                                    }}
                                >
                                    Valider
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                <div style={{display: 'flex', margin: 25}}>
                    <p>Gestion \</p>
                    <p style={{color: purple, marginLeft: 5, fontWeight: 'bold'}}>Axes d'interventions</p>
                </div>

                <div style={{maxWidth: 800, margin: '0 auto', padding: 20}}>
                    <div style={{backgroundColor: 'white', padding: 20, borderRadius: 8, boxShadow: '0 2px 4px rgba(0,0,0,0.1)', marginBottom: 20}}>
                        <p style={{marginTop: 0, fontSize: 18, textAlign: 'center'}}>Créer un axe d'intervention</p>
                        
                        <div style={{marginBottom: 15}}>
                            <p style={{display: 'block', marginBottom: 6}}>Intitulé</p>
                            <input
                                type="text"
                                value={intitule}
                                onChange={e => setIntitule(e.target.value)}
                                style={{width: '100%', padding: 10, borderRadius: 4, border: '1px solid #ccc'}}
                                placeholder="Ex: Développement durable"
                            />
                        </div>

                        <div style={{display: 'flex', gap: 10, justifyContent: 'flex-end'}}>
                            <button
                                onClick={submit}
                                style={{padding: '10px 20px', borderRadius: 4, backgroundColor: '#59B44A', color: 'white', border: 'none', cursor: 'pointer'}}
                            >
                                Créer
                            </button>
                        </div>
                    </div>

                    <div style={{backgroundColor: 'white', padding: 20, borderRadius: 8, boxShadow: '0 2px 4px rgba(0,0,0,0.1)'}}>
                        <p style={{marginTop: 0, fontSize: 18, textAlign: 'center'}}>Liste des axes d'interventions</p>
                        
                        {(!axes || axes.length === 0) ? (
                            <p style={{color: '#666', textAlign: 'center', padding: 20}}>Aucun axe d'intervention</p>
                        ) : (
                            <div style={{display: 'flex', flexDirection: 'column', gap: 10}}>
                                {axes.map(axe => (
                                    <div 
                                        key={axe.id} 
                                        style={{
                                            display: 'flex', 
                                            alignItems: 'center', 
                                            padding: 15, 
                                            border: '1px solid #eee', 
                                            borderRadius: 6,
                                            backgroundColor: 'white'
                                        }}
                                    >
                                        <p style={{flex: 1}}>{axe.intitule}</p>
                                        <div style={{display: 'flex', gap: 10}}>
                                            <button
                                                onClick={() => editAxe(axe)}
                                                style={{
                                                    padding: '6px 12px',
                                                    borderRadius: 4,
                                                    backgroundColor: '#6571FE',
                                                    color: 'white',
                                                    border: 'none',
                                                    cursor: 'pointer',
                                                    fontSize: 14
                                                }}
                                            >
                                                Modifier
                                            </button>
                                            <button
                                                onClick={() => {
                                                    setIdSelected(axe.id);
                                                    setDialogModalVisible(true);
                                                }}
                                                style={{border: 'none', background: 'transparent', cursor: 'pointer', padding: '6px'}}
                                            >
                                                <Trash width="18" />
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </Access>
        </div>
    );
}

export default AxesInterventions;
